// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
const routerActions = require('client-v2/common/state/router/actions')
// ShareModal imports
const shareModalActions = require('client-v2/common/containers/share-modal/actions')
const shareModalSelectors = require('client-v2/common/containers/share-modal/selectors')

function mapStateToProps() {
  return function (state) {
    if (!shareModalSelectors.isFriendsVisible(state)) {
      return { isVisible: false }
    }
    return {
      isVisible: true,
      friends: shareModalSelectors.friendsSearch(state),
      friendsState: shareModalSelectors.friendsState(state),
      isSocialAuthCardVisible: shareModalSelectors.isSocialAuthCardVisible(state),
      submitState: shareModalSelectors.submitState(state),
      user: state.user
    }
  }
}

const mapDispatchToProps = {
  onFriendClick: shareModalActions.toggleFriend,
  onFriendsShare: shareModalActions.shareWithFriends,
  onNavigate: routerActions.navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./share-friends-dumb')
    )
  )
)
